var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53845 5.57782H8.76922M5.53845 9.62325H12.8077M19.2692 9.62325L14.4231 17.7002L8.76922 14.4694L5.53845 19.3156M20.8846 22.541H3.11538C2.22323 22.541 1.5 21.8178 1.5 20.9256V3.1564C1.5 2.26425 2.22323 1.54102 3.11538 1.54102H20.8846C21.7768 1.54102 22.5 2.26425 22.5 3.1564V20.9256C22.5 21.8178 21.7768 22.541 20.8846 22.541Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu1);
export default __webpack_public_path__ + "static/media/iconMenu1.fe1cef797c461e8ae210272b02544072.svg";
export { ForwardRef as ReactComponent };